exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pie-chart-container {\n  position: relative;\n  font-size: 10px;\n}\n\n.pie-chart-container svg {\n  width: 100%;\n  height: 100%;\n}\n\n.pie-chart-container path.slice {\n  stroke-width: 2px;\n}\n\n.pie-chart-container polyline {\n  opacity: .3;\n  stroke: #4D4D4D;\n  stroke-width: 1px;\n  fill: none;\n}\n\n.pie-chart-container .mid-label {\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate(0, -50%);\n  -webkit-transform: translate(0, -50%);\n  font-weight: 300;\n}\n\n.pie-chart-container .hidden {\n  opacity: 0;\n}\n\n.dummy-pie-chart {\n  position: relative;\n}\n\n.dummy-pie-chart .mid-label {\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate(0, -50%);\n  -webkit-transform: translate(0, -50%);\n  font-weight: 300;\n  color: #E6E6E6;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/pie-chart/widget.scss
// module id = 1908
// module chunks = 0